var map = {
	"./images/logo.svg": "./src/assets/images/logo.svg",
	"./images1/logo.svg": "./src/assets/images1/logo.svg",
	"./images2/logo.svg": "./src/assets/images2/logo.svg",
	"./images3/logo.svg": "./src/assets/images3/logo.svg",
	"./images4/logo.svg": "./src/assets/images4/logo.svg",
	"./images5/logo.svg": "./src/assets/images5/logo.svg",
	"./images52/logo.svg": "./src/assets/images52/logo.svg",
	"./images53/logo.svg": "./src/assets/images53/logo.svg",
	"./images55/logo.svg": "./src/assets/images55/logo.svg",
	"./images56/logo.svg": "./src/assets/images56/logo.svg",
	"./images57/logo.svg": "./src/assets/images57/logo.svg",
	"./images58/logo.svg": "./src/assets/images58/logo.svg",
	"./images6/logo.svg": "./src/assets/images6/logo.svg",
	"./images60/logo.svg": "./src/assets/images60/logo.svg",
	"./images7/logo.svg": "./src/assets/images7/logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/images.*\\/logo\\.svg$";